/**
 * @module app.pp
 */

import * as CD from 'app/cd/models/essette-api';
import { autoinject } from 'aurelia-framework';
import { ComponentBase, IForm } from 'app/shared/lib/essette-site';
import { apiCall } from 'app/shared/lib/api/api';
import { ProviderService } from 'app/cd/services/provider-service';
import { Toaster } from 'app/shared/lib/toaster';
import { deepClone } from 'app/shared/lib/utilities';
import { getReference } from 'app/shared/models/essette-types';



@autoinject()
export class SaveContactCustomElement extends ComponentBase implements IForm {

    ////****************** Fields and Properties ************************************////
    protected contact: CD.ProviderContact = { id: null };
    protected contactOriginal: CD.ProviderContact | null = null;


    ////****************** Element References ***************************************////



    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly providerService: ProviderService,
        private readonly toaster: Toaster,
        ...rest: any[]) {

        super(...rest);
        this.logger.source = this;
    }

    protected async bind(): Promise<void> {
    }

    ////****************** Events ***************************************************////


    ////****************** Functions ************************************************////
    public async LoadProviderContact(providerContact: CD.ProviderContract | null): Promise<void> {
        this.reset();
        this.contactOriginal = providerContact || {};
        this.contact = deepClone(this.contactOriginal);
    }

    //per yaml,
    //we can't have empty in phone or fax.
    //also leaving them undefined means we can't update them.
    //I don't know if we have this function in some utility somewhere, like noop...
    private forceNull(a: string | null | undefined): string | null {
        if(a === undefined || a?.trim() === '') return null;
        return a;
    }

    private buildSaveContact(): CD.ProviderContact | null {

        const saveContact: CD.ProviderContact = {
            id: this.contact.id,
            location: {
                id: this.contact.location?.id
            },
            name: {
                full: this.contact.name?.full
            },
            department: this.contact.department,
            title: this.contact.title,
            emailAddress: this.forceNull(this.contact.emailAddress),
            phoneNumber: {}
        }

        if(this.contact.phoneNumber) {
            saveContact.phoneNumber!.primary = {
                country: { id: '1' },
                number: this.contact.phoneNumber.primary?.number?.replace(/[^0-9]/g, '') || null,
                extension: this.contact.phoneNumber.primary?.extension || null
            }
            saveContact.phoneNumber!.fax = {
                country: { id: '1' },
                number: this.contact.phoneNumber.fax?.number?.replace(/[^0-9]/g, '') || null,
                extension: this.contact.phoneNumber.fax?.extension || null
            }
        }

        if(this.contact.address?.mailing) {
            saveContact.address = {
                mailing: {
                    street1: this.contact.address?.mailing?.street1,
                    street2: this.contact.address?.mailing?.street2,
                    city: this.contact.address?.mailing?.city,
                    region: getReference(this.contact.address?.mailing?.region),
                    area: getReference(this.contact.address?.mailing?.area),
                    country: getReference(this.contact.address.mailing.country),
                    postalCode: this.contact.address?.mailing?.postalCode
                }
            }
        }

        return saveContact;
    }

    ////****************** IForm ****************************************************////
    public reset(): void {
        this.contact = { id: null };
        this.contactOriginal = null;
    }
    public hasChanges(): boolean {
        return JSON.stringify(this.contact) !== JSON.stringify(this.contactOriginal)
    }
    public submittedChanges?: any;
    public async submit(): Promise<boolean> {
        return this.saveContact();
    }


    ////****************** Service Calls ********************************************////
    @apiCall
    private async saveContact(): Promise<boolean> {
        const contact = this.buildSaveContact();
        if(!contact) { return false; }

        try {
            this.state.beginSave();

            const response = await this.providerService.saveProviderContact(contact);
            this.toaster.standard.saved('cd:providerContact.$', response.isSuccessful);
            return response.isSuccessful;
        } catch(error) {
            throw error;
        } finally {
            this.state.endSave();
        }
    }
}
